<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M6.5 9.00003C8.433 9.00003 10 7.43303 10 5.50003C10 3.56703 8.433 2.00003 6.5 2.00003C4.567 2.00003 3 3.56703 3 5.50003C3 7.43303 4.567 9.00003 6.5 9.00003Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      d="M12 16V15.1765C12 14.3028 11.6313 13.5826 10.9749 12.9649C10.3185 12.3471 9.42826 12 8.5 12H4.5C3.57174 12 2.6815 12.3471 2.02513 12.9649C1.36875 13.5826 1 14.3028 1 15.1765V16"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      d="M12 9.99815C14.2555 9.74771 16 7.82282 16 5.49907C16 3.17532 14.2555 1.25043 12 1V3.02309C13.1367 3.25672 14 4.27116 14 5.49907C14 6.72699 13.1367 7.74142 12 7.97505V9.99815Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M14 13.0464C14.491 13.1385 14.9404 13.3645 15.2895 13.693C15.7847 14.1591 16 14.6286 16 15.1765V16C16 16.5523 16.4477 17 17 17C17.5523 17 18 16.5523 18 16V15.1765C18 13.9771 17.4778 13.0061 16.6602 12.2366C15.9334 11.5525 14.9935 11.1325 14 11.0266V13.0464Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ClientsIcon',
  };
</script>
